import { Typography } from 'antd'
import PropTypes from 'prop-types'
import { Navigate } from 'react-router-dom'
import { useTheme } from 'react-jss'
import {
  useCurrentUserPracticeId,
  useIsAdmin,
} from '../../redux/slices/session'
import { useSelectedPractice } from '../../context/PracticeContext'

const { Title } = Typography

export default function PracticeSelectView({ routeMethod }) {
  const { brandPrimary } = useTheme()
  const isAdmin = useIsAdmin()
  const currentPracticeId = useCurrentUserPracticeId()
  const { selectedPracticeId } = useSelectedPractice()

  if (isAdmin) {
    if (selectedPracticeId) {
      return <Navigate to={routeMethod({ practiceId: selectedPracticeId })} />
    }

    return (
      <div>
        <Title level={4} style={{ color: brandPrimary }}>
          Please select a practice from the header to continue.
        </Title>
      </div>
    )
  }

  return <Navigate to={routeMethod({ practiceId: currentPracticeId })} />
}

PracticeSelectView.propTypes = {
  routeMethod: PropTypes.func.isRequired,
}
